import { Row } from "antd";
import { ITotalCard } from "../types/ITotalCard";
import { getFormattedCurrency } from "../../../../../../../../../lib/currencyFormatter";
import { IOption } from "../../../../../../../../../types/Option";
import { DataChildRow } from "./DataChildRow";
import { useMemo } from "react";

type DataCardProps = {
  data: any;
  dataMap: ITotalCard;
};

export const DataCard = ({ data, dataMap }: DataCardProps) => {
  const value: string = useMemo(
    () => getFormattedCurrency(data[dataMap.name] || 0),
    [data, dataMap.name]
  );

  return (
    <Row
      className={`d-block total-card ${dataMap.higlight ? " mr-4 main" : ""}`}
    >
      <Row className="py-2 px-4 justify-end total-card-header">
        <Row className="w-100 d-block">
          <p className="d-flex justify-end w-100 text-sm my-0">
            {dataMap.label}
          </p>
          <Row className="w-100 justify-end">
            <p className="text w-500 my-0 elipsis" title={value}>
              {value}
            </p>
          </Row>
        </Row>
      </Row>
      <Row className="d-block mt-2">
        {dataMap.children.map((item: IOption, i: number) => (
          <DataChildRow
            key={i}
            data={item}
            values={data}
            higlight={dataMap.higlight}
          />
        ))}
      </Row>
    </Row>
  );
};
